document.addEventListener('DOMContentLoaded', () => {
  const filterHeader = document.querySelector('.filter-by-sorting .filter-header');
  const arrowIcon = document.querySelector('.filter-by-sorting .arrow-icon');
  const filterContent = document.querySelector('.filter-by-sorting .filter-content');

  if (filterHeader && filterContent) {
    filterHeader.addEventListener('click', () => {
      // Toggle visibility of the dropdown
      filterContent.classList.toggle('hidden');

      // Rotate the arrow icon
      arrowIcon.classList.toggle('rotated');
    });
  }
});
